

<div class="profile-container">
    <div class="">
        <div class="profile-content">
            <div class="personal-details">
                <div class="row">
                  <div class="col-md-3 col-lg-3">
                    <select name="" id="" class="form-control" [(ngModel)]="userID">
                        <option value="" disabled selected hidden>---select user---</option>
                        <option *ngFor="let user of usersList" [value]="user.userId" >{{user.userName}}</option>
                    </select>
                  </div>
                  <div class="col-md-5 col-lg-5 right" style="display: flex;padding-left: 0;justify-content: space-between;">
                        <div class="" style="width:39%">
                            <input type="date" [(ngModel)]="date1" class="form-control">
                        </div>
                        <div class="" style="width:39%">
                            <input type="date" [(ngModel)]="date2" class="form-control">
                        </div>
                        <div class="" style="width:20%">
                            <button (click)="filterByTicketStatusAndBetweenDates()" class="btn btn-primary">search</button>
                        </div>
                  </div>
                </div>
                <div class="row">
                      <div class="col-md-10 col-lg-10">
                        <div class="map-container">
                          <div class="map-frame">
                            <div id="map">
                            </div>
                          </div>
                        </div>
                        <div class="status-table" *ngIf="taskStatus != 0">
                          <table class="table">
                            <thead>
                              <tr>
                                <th style="width: 30%;">Note</th>
                                <th style="width: 20%;text-align: center;">Status</th>
                                <th style="width: 50%;text-align: center;">Date</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr *ngFor="let status of taskStatus; let i = index">
                                <td style="width: 30%;">{{status.note}}</td>
                                <td style="width: 20%;text-align: center;">{{status.taskStatus}}</td>
                                <td style="width: 50%;text-align: center;">{{status.updatedDate | date:'medium'}}</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div class="col-md-2 col-lg-2" style="padding-left: 0;">
                        <div class="usersList">
                            <label style="cursor: pointer" (click)="Reloadpage()">Task slNo's</label>
                            <h4 class="nodata" *ngIf="filteredData == 0" >No Task Available</h4>
                            <p *ngFor="let list of filteredData" (click)="getSingleTask(list.id)" >{{list.taskSlNo}}</p>
                        </div>
                      </div>
                </div>
                <!-- <table class="table table-striped" *ngIf="filteredData.lenght != 0">
                    <thead>
                      <tr>
                        <th scope="col">Task SlNo</th>
                        <th scope="col">Assigned To</th>
                        <th scope="col">Task Name</th>
                        <th scope="col">Description</th>
                        <th scope="col">Completed %</th>
                        <th scope="col">Status</th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let filteredData of filteredData;let i = index">
                        <td scope="col">{{filteredData.taskSlNo}}</td>
                        <td scope="col">{{filteredData.assignedToUserName}}</td>
                        <td scope="col">{{filteredData.name}}</td>
                        <td scope="col">{{filteredData.description}}</td>
                        <th scope="col">{{filteredData.completedPercentage}}%</th>
                        <td scope="col">{{filteredData.latestTaskStatus}}</td>
                      </tr>
                    </tbody>
                </table> -->
            </div>
        </div>
    </div>
</div>